document.addEventListener('DOMContentLoaded', function() {

  // Vérifier et nettoyer les emballages cadeau au chargement
  checkAndRemoveOrphanedGiftWraps();

  // Surveiller les changements dans le panier (suppression de produits)
  const observer = new MutationObserver(function(mutations) {
    let cartChanged = false;
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' || mutation.type === 'attributes') {
        cartChanged = true;
      }
    });

    if (cartChanged) {
      // Attendre un peu pour que les changements se propagent
      setTimeout(() => {
        checkAndRemoveOrphanedGiftWraps();
      }, 500);
    }
  });

  // Observer les changements dans la section du panier
  const cartItemsSection = document.querySelector('#main-cart-items');
  if (cartItemsSection) {
    observer.observe(cartItemsSection, {
      childList: true,
      subtree: true,
      attributes: true
    });
  }

  // Gérer les clics sur les boutons d'emballage cadeau
  document.addEventListener('click', function(event) {
    if (event.target.closest('.gift-wrap-item-button')) {
      const button = event.target.closest('.gift-wrap-item-button');
      const isActive = button.classList.contains('gift-wrap-item-button--active');

      if (isActive) {
        removeGiftWrapFromItem(button);
      } else {
        addGiftWrapToItem(button);
      }
    }
  });

  function addGiftWrapToItem(button) {
    const variantId = button.dataset.variantId;

    // Désactiver le bouton pendant le traitement
    button.disabled = true;
    const originalText = button.querySelector('.gift-wrap-text').innerHTML;
    button.querySelector('.gift-wrap-text').innerHTML = 'Ajout en cours...';

    // D'abord ajouter la propriété _gift_wrap à l'article
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const itemIndex = cart.items.findIndex(item => item.variant_id == variantId);
        if (itemIndex === -1) throw new Error('Article non trouvé');

        const item = cart.items[itemIndex];
        const properties = item.properties || {};
        properties['_gift_wrap'] = 'true';

        // Mettre à jour les propriétés de l'article
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            line: itemIndex + 1,
            properties: properties
          })
        });
      })
      .then(() => {
        // Ensuite ajouter le produit emballage cadeau
        const handles = ['emballage-cadeau', 'emballage_cadeau', 'gift-wrap', 'gift_wrap'];
        return findAndAddGiftWrapProduct(handles);
      })
      .then(() => {
        // Recharger la page pour mettre à jour
        window.location.reload();
      })
      .catch(error => {
        // En cas d'erreur, remettre le bouton dans l'état initial
        button.disabled = false;
        button.querySelector('.gift-wrap-text').innerHTML = originalText;
        console.error('Erreur lors de l\'ajout d\'emballage cadeau:', error);
      });
  }

  function removeGiftWrapFromItem(button) {
    const variantId = button.dataset.variantId;

    // Désactiver le bouton pendant le traitement
    button.disabled = true;
    const originalText = button.querySelector('.gift-wrap-text').innerHTML;
    button.querySelector('.gift-wrap-text').innerHTML = 'Suppression en cours...';

    // D'abord supprimer la propriété _gift_wrap de l'article
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const itemIndex = cart.items.findIndex(item => item.variant_id == variantId);
        if (itemIndex === -1) throw new Error('Article non trouvé');

        const item = cart.items[itemIndex];
        const properties = item.properties || {};
        properties['_gift_wrap'] = null;

        // Mettre à jour les propriétés de l'article
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            line: itemIndex + 1,
            properties: properties
          })
        });
      })
      .then(() => {
        // Ensuite supprimer un produit emballage cadeau du panier
        return removeOneGiftWrapProduct();
      })
      .then(() => {
        // Vérifier s'il faut supprimer les emballages cadeau orphelins
        return checkAndRemoveOrphanedGiftWraps(false);
      })
      .then(() => {
        // Recharger la page pour mettre à jour
        window.location.reload();
      })
      .catch(error => {
        // En cas d'erreur, remettre le bouton dans l'état initial
        button.disabled = false;
        button.querySelector('.gift-wrap-text').innerHTML = originalText;
        console.error('Erreur lors de la suppression d\'emballage cadeau:', error);
        // Recharger quand même pour synchroniser l'état
        setTimeout(() => window.location.reload(), 1000);
      });
  }

  function findAndAddGiftWrapProduct(handles) {
    let lastError;

    function tryHandle(index) {
      if (index >= handles.length) {
        throw lastError || new Error('Aucun produit emballage trouvé');
      }

      return fetch('/products/' + handles[index] + '.js')
        .then(response => {
          if (!response.ok) throw new Error('Produit non trouvé');
          return response.json();
        })
        .then(product => {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: product.variants[0].id,
                quantity: 1
              }]
            })
          });
        })
        .catch(error => {
          lastError = error;
          return tryHandle(index + 1);
        });
    }

    return tryHandle(0);
  }

  function removeOneGiftWrapProduct() {
    return fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const handles = ['emballage-cadeau', 'emballage_cadeau', 'gift-wrap', 'gift_wrap'];

        // Trouver le premier produit d'emballage dans le panier
        for (let i = 0; i < cart.items.length; i++) {
          const item = cart.items[i];
          const itemHandle = (item.product_handle || '').toLowerCase();
          const itemTitle = (item.title || '').toLowerCase();

          // Utiliser la même logique que le code console qui a fonctionné
          const isGiftWrap = handles.includes(itemHandle) ||
                           handles.some(h => itemTitle.includes(h.replace(/[-_]/g, ' ')));

          if (isGiftWrap) {
            // Supprimer cet article
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                line: i + 1,
                quantity: Math.max(0, item.quantity - 1)
              })
            });
          }
        }
      });
  }

  function checkAndRemoveOrphanedGiftWraps(autoReload = true) {
    return fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (!cart.items || cart.items.length === 0) return;

        const handles = ['emballage-cadeau', 'emballage_cadeau', 'gift-wrap', 'gift_wrap', 'papier-cadeau', 'papier_cadeau'];

        // Compter les produits normaux et identifier les produits avec emballage
        let normalProductsCount = 0;
        let giftWrapItems = [];
        let productsWithGiftWrap = new Set();

        cart.items.forEach((item, index) => {
          const itemHandle = (item.product_handle || '').toLowerCase();
          const itemTitle = (item.title || '').toLowerCase();

          // Utiliser la même logique que le code console qui a fonctionné
          const isGiftWrap = handles.includes(itemHandle) ||
                            handles.some(h => itemTitle.includes(h.replace(/[-_]/g, ' ')));

          if (isGiftWrap) {
            giftWrapItems.push({index: index + 1, quantity: item.quantity});
          } else {
            normalProductsCount++;
            // Vérifier si ce produit a un emballage cadeau
            if (item.properties && item.properties['_gift_wrap'] === 'true') {
              productsWithGiftWrap.add(item.variant_id);
            }
          }
        });

        // Cas 1: Aucun produit normal mais des emballages cadeau -> supprimer tous les emballages
        if (normalProductsCount === 0 && giftWrapItems.length > 0) {
          return removeAllGiftWrapProducts(giftWrapItems, autoReload);
        }

        // Cas 2: Il y a des produits normaux mais trop d'emballages par rapport aux produits qui en ont
        if (normalProductsCount > 0 && giftWrapItems.length > 0) {
          const expectedGiftWraps = productsWithGiftWrap.size;
          const actualGiftWraps = giftWrapItems.reduce((total, item) => total + item.quantity, 0);

          // Si il y a plus d'emballages que de produits qui en ont besoin
          if (actualGiftWraps > expectedGiftWraps) {
            const excessGiftWraps = actualGiftWraps - expectedGiftWraps;
            return removeExcessGiftWraps(giftWrapItems, excessGiftWraps, autoReload);
          }
        }
      })
      .catch(error => {
        console.log('Erreur lors de la vérification des emballages cadeau:', error);
      });
  }

  function removeExcessGiftWraps(giftWrapItems, excessCount, autoReload = true) {
    let removedCount = 0;
    const removePromises = [];

    for (const item of giftWrapItems) {
      if (removedCount >= excessCount) break;

      const quantityToRemove = Math.min(item.quantity, excessCount - removedCount);
      const newQuantity = item.quantity - quantityToRemove;

      removePromises.push(
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            line: item.index,
            quantity: newQuantity
          })
        })
      );

      removedCount += quantityToRemove;
    }

    return Promise.all(removePromises)
      .then(() => {
        if (autoReload) {
          window.location.reload();
        }
      })
      .catch(error => {
        console.log('Erreur lors de la suppression des emballages cadeau en excès:', error);
      });
  }

  function removeAllGiftWrapProducts(giftWrapItems, autoReload = true) {
    // Supprimer tous les emballages cadeau en parallèle
    const removePromises = giftWrapItems.map(item => {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: item.index,
          quantity: 0
        })
      });
    });

    return Promise.all(removePromises)
      .then(() => {
        if (autoReload) {
          // Recharger la page pour mettre à jour l'affichage
          window.location.reload();
        }
      })
      .catch(error => {
        console.log('Erreur lors de la suppression des emballages cadeau:', error);
      });
  }

  function toggleButton(button, isActive) {
    const svg = button.querySelector('svg');
    const text = button.querySelector('.gift-wrap-text');

    if (isActive) {
      button.classList.add('gift-wrap-item-button--active');
      if (svg) {
        svg.innerHTML = '<path fill="currentColor" d="m1805 205l-755 755l755 755l-90 90l-755-755l-755 755l-90-90l755-755l-755-755l90-90l755 755l755-755l90 90z" />';
      }
      if (text) {
        text.innerHTML = 'Supprimer l\'emballage cadeau. <br>- 2,50€';
      }
    } else {
      button.classList.remove('gift-wrap-item-button--active');
      if (svg) {
        svg.innerHTML = '<path fill="currentColor" d="M1792 768v1280H128V768h292q-35-59-35-128q0-53 20-99t54-82t81-55t100-20q97 0 181 45t139 127q54-81 138-126t182-46q53 0 99 20t82 55t55 81t20 100q0 34-9 66t-27 62h292zM896 896H256v1024h640V896zm0-128q0-53-20-99t-55-82t-81-55t-100-20q-27 0-50 10t-40 27t-28 41t-10 50q0 27 10 50t27 40t41 28t50 10h256zm384-256q-53 0-99 20t-82 55t-55 81t-20 100h256q27 0 50-10t40-27t28-41t10-50q0-27-10-50t-27-40t-41-28t-50-10zm384 384h-640v1024h640V896z" />';
      }
      if (text) {
        text.innerHTML = 'Ajouter un emballage cadeau à ce panneau. <br>+ 2,50€';
      }
    }
  }

});